import templates from "@gotombola/react-ds/lib/templates";

export default {
    ...templates,
};